// extracted by mini-css-extract-plugin
module.exports = {"photo-priority":"photo-priority-single-author-m__photo-priority__1Jkgp"};